import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './CustomSolution.css';

const CustomSolution = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  // 온라인 견적 섹션으로 이동하는 함수
  const scrollToOnlineQuote = () => {
    const currentPath = window.location.pathname;
    const targetPath = language === 'en' ? `/en/customer-support` : `/ko/customer-support`;
    
    if (currentPath === targetPath) {
      // 같은 페이지에 있으면 바로 스크롤
      const scrollToElement = () => {
        const element = document.getElementById('online-quote');
        if (element) {
          const headerHeight = 100; // 헤더 높이
          const elementPosition = element.offsetTop - headerHeight - 30; // 헤더 높이 + 여백
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        } else {
          // 요소가 아직 로드되지 않았다면 다시 시도
          setTimeout(scrollToElement, 100);
        }
      };
      scrollToElement();
    } else {
      // 다른 페이지면 페이지 이동 후 스크롤
      navigate(targetPath);
      
      // 페이지 이동 후 여러 번 시도하여 확실하게 스크롤
      const attemptScroll = (attempts = 0) => {
        setTimeout(() => {
          const element = document.getElementById('online-quote');
          if (element) {
            const headerHeight = 100; // 헤더 높이
            const elementPosition = element.offsetTop - headerHeight - 30; // 헤더 높이 + 여백
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          } else if (attempts < 10) {
            // 최대 10번까지 시도 (2초간)
            attemptScroll(attempts + 1);
          }
        }, 200);
      };
      attemptScroll();
    }
  };

  const handleQuoteRequest = () => {
    scrollToOnlineQuote();
  };

  const handleCustomerService = () => {
    // 고객지원 페이지로 이동
    const path = '/customer-support';
    const languagePath = language === 'en' ? `/en${path}` : path;
    navigate(languagePath);
  };

  return (
    <section className="custom-solution">
      <div className="custom-solution-container">
        <div className="custom-solution-content">
          <h2 className="custom-solution-title">맞춤형 솔루션이 필요하신가요?</h2>
          <p className="custom-solution-subtitle">
            전문 엔지니어가 고객의 요구사항에 최적화된 열교환 솔루션을 제안해드립니다
          </p>
          <div className="custom-solution-buttons">
            <button onClick={handleQuoteRequest} className="quote-button">
              온라인 견적 요청 →
            </button>
            <button onClick={handleCustomerService} className="contact-button">
              고객센터 문의
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomSolution;
